import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { API, formatApiErrorDetail } from "@/auth";

export default function ChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { document.title = "Change Password | Admin"; }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) return toast.error("New password must be at least 6 characters");
    if (next !== confirm) return toast.error("Passwords do not match");
    setSaving(true);
    try {
      await axios.post(
        `${API}/auth/change-password`,
        { current_password: current, new_password: next },
        { withCredentials: true }
      );
      toast.success("Password updated");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="ap-card" data-testid="admin-change-password-page">
      <h2 className="ap-card-title">CHANGE PASSWORD</h2>
      <form onSubmit={submit} className="ap-form">
        <label className="ap-field">
          <span>Current Password:</span>
          <Input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </label>
        <label className="ap-field">
          <span>New Password:</span>
          <Input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} required />
        </label>
        <label className="ap-field">
          <span>Confirm New Password:</span>
          <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        </label>
        <div className="ap-form-footer">
          <button className="ap-btn ap-btn-primary" data-testid="cp-submit" type="submit" disabled={saving}>
            {saving ? "Updating..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
}
